import { NgModule } from '@angular/core';
import { RouterModule, Routes, ExtraOptions } from '@angular/router';
import { environment } from '../environments/environment';

import { LayoutComponent } from './components/layout/layout.component';
import { ComingSoonComponent } from '@pages/coming-soon/coming-soon.component';
import { TermsConditionsComponent } from './components/terms-conditions/terms-conditions.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { AboutUsComponent } from './components/about-us/about-us.component';
import { SupplierComponent } from './components/supplier/supplier.component';
import { KickstarterAlternateComponent } from '@pages/kickstarter-alternate/kickstarter-alternate.component';

const routerOptions: ExtraOptions = {
  scrollPositionRestoration: 'top',
  anchorScrolling: 'enabled',
  useHash: true,
};

let routes: Routes = [];

if (environment.showComingSoon) {
  // Show Coming Soon page for all routes, but allow access to terms and privacy
  routes = [
    {
      path: '',
      component: ComingSoonComponent,
    },
    {
      path: 'terms-conditions',
      component: TermsConditionsComponent,
    },
    {
      path: 'privacy-policy',
      component: PrivacyPolicyComponent,
    },
    {
      path: 'about-us',
      component: AboutUsComponent,
    },
    {
      path: 'suppliers',
      component: SupplierComponent,
    },
    {
      path: 'alternative-to-kickstarter',
      component: KickstarterAlternateComponent,
    },
    // Wildcard route must always be last
    {
      path: '**',
      redirectTo: '',
      pathMatch: 'full',
    },
  ];
} else {
  routes = [
    {
      path: '',
      redirectTo: 'home',
      pathMatch: 'full',
    },
    {
      path: '',
      component: LayoutComponent,
      children: [
        {
          path: 'about-us',
          component: AboutUsComponent,
        },
        {
          path: 'terms-conditions',
          component: TermsConditionsComponent,
        },
        {
          path: 'privacy-policy',
          component: PrivacyPolicyComponent,
        },
        {
          path: 'suppliers',
          component: SupplierComponent,
        },
        {
          path: 'alternative-to-kickstarter',
          component: KickstarterAlternateComponent,
        },
        {
          path: '',
          loadChildren: () =>
            import('./pages/pages.module').then((m) => m.PagesModule),
        },
      ],
    },
  ];
}

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
